import { render, staticRenderFns } from "./academy-list-toolbar.vue?vue&type=template&id=708c2906&"
import script from "./academy-list-toolbar.vue?vue&type=script&lang=js&"
export * from "./academy-list-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports